export * from "./formContext"

import _Form from "./Form.vue"

/** @deprecated */
export const Form = _Form
